export const WELCOME_POPUP_CONFIG = {
    in: {
        title: "Welcome to AInstein!",
    },

};